<aside aria-label="Form Editor">
  <h2>Endpoint</h2>
  <label>
    Endpoint Name:
    <input type="text" class="no-margin" [(ngModel)]="selectedState.name" (ngModelChange)="selectedStateNameChanged($event)"
      name="stateName">
  </label>
  <div [ngClass]="{'hide': !showDuplicateNameWarning}" class="cell small-12 small-font-size red">Duplicate name, please
    change the state name!</div>
  <div class="form-button-group margin-top">
    <button class="button hollow" (click)="cancel()">Cancel</button>
  </div>
</aside>